<template>
  <section :class="['section', 'child-view', 'section--expertise', 'section--expertise-child', 'section--expertise-graphic']">
    <div class="wrapper" :class="{ 'with-modal': isModalVisible}">
      <div class="content">
        <div class="heading">
          <div class="back-btn">
            <router-link
              :to="`/expertise`">
            </router-link>
            <span>back</span>
          </div>
        </div>
        <div class="expertise-holder">
          <ul class="parts-number">
            <li class="number-4">
              <span class="number">/4</span>
              <span class="text">Graphic Design</span>
              <ul class="list-tools">
                <li>
                  <img src="../assets/images/programs_icons/adobeaftereffect.svg" alt="adobe aftereffect">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/adobeillustrator.svg" alt="adobe illustrator">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/adobephotoshop.svg" alt="adobe photoshop">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/adobe_indesign.svg" alt="adobe indesign">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/figma.svg" alt="figma">
                </li>
              </ul>
            </li>
          </ul>
          <div class="circle-holder">
            <div class="expertise-area">
              <div class="expertise-container art-container">
                <span class="circle-title">Art</span>
                <ul class="circle-block">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li class="circle-button">
                    <div class="text-holder"
                      @click="openModal('installation')">
                      <span class="text">Installation</span>
                    </div>
                  </li>
                  <li class="circle-button">
                    <div class="text-holder"
                      @click="openModal('walls-art')">
                      <span class="text">Wall's Art</span>
                    </div>
                  </li>
                  <li class="circle-button">
                    <div class="text-holder"
                      @click="openModal('merchandise')">
                      <span class="text">Merchandise</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="expertise-container illustration-container">
                <span class="circle-title">Illustration</span>
                <ul class="circle-block">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li class="circle-button">
                    <div class="text-holder"
                      @click="openModal('posters')">
                      <span class="text">Posters</span>
                    </div>
                  </li>
                  <li class="circle-button">
                    <div class="text-holder"
                      @click="openModal('banners')">
                      <span class="text">Banners</span>
                    </div>
                  </li>
                  <li class="circle-button">
                    <div class="text-holder"
                      @click="openModal('presentation')">
                      <span class="text">Presentation</span>
                    </div>
                  </li>
                  <li class="circle-button">
                    <div class="text-holder"
                      @click="openModal('iconographic')">
                      <span class="text">Iconographic</span>
                    </div>
                  </li>
                  <li class="circle-button">
                    <div class="text-holder"
                      @click="openModal('iconography')">
                      <span class="text">Iconography</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="expertise-container branding-container">
                <span class="circle-title">Branding</span>
                <ul class="circle-block">
                  <li class="circle-button right-side">
                    <div class="text-holder"
                      @click="openModal('logo')">
                      <span class="text">Logo</span>
                    </div>
                  </li>
                  <li class="circle-button right-side">
                    <div class="text-holder"
                      @click="openModal('color-design')">
                      <span class="text">Color Design</span>
                    </div>
                  </li>
                  <li class="circle-button right-side">
                    <div class="text-holder"
                      @click="openModal('brand-identity')">
                      <span class="text">Brand Identity</span>
                    </div>
                  </li>
                  <li class="circle-button">
                    <div class="text-holder"
                      @click="openModal('character')">
                      <span class="text">Character</span>
                    </div>
                  </li>
                  <li class="circle-button">
                    <div class="text-holder"
                      @click="openModal('brand-book')">
                      <span class="text">Brand Book</span>
                    </div>
                  </li>
                  <li class="circle-button">
                    <div class="text-holder"
                      @click="openModal('e-mailing')">
                      <span class="text">E-mailing</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div><!--end content-->
    </div>
    <window-modal v-show="isModalVisible" v-model="modalData[activeItem]" @close="closeModal"></window-modal>
  </section>
</template>

<script>
import Footer from '@/components/UI/Footer';
import { mapActions } from 'vuex';
import WindowModal from '@/components/modals/WindowModal.vue';

export default {
  mounted() {
    document.addEventListener('keydown', this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  data() {
    return {
      isModalVisible: false,
      activeItem: 'iconography',
      modalData: {
        iconography: {
          title: 'Iconography',
          content: '"Iconography" in graphic design involves the creation and design of icons, which are small, symbolic graphical elements used to represent specific concepts, actions, or features, often in user interfaces or signage. Iconography aims to convey information quickly and universally, making it a crucial component of visual communication and user experience design.',
          linkUrl: 'https://google.com',
          styleClass: 'slice',
        },
        iconographic: {
          title: 'Iconographic',
          content: 'This is a visual representation of complex information, data, or statistics presented in a clear and easily understandable format. It combines text, icons, illustrations, and design elements to convey information quickly and effectively, making it a valuable tool for simplifying and enhancing the communication of complex ideas or facts.',
          linkUrl: 'https://google.com',
          styleClass: 'slice',
        },
        presentation: {
          title: 'Presentation',
          content: 'A "Presentation" involves the visual design and layout of materials used to convey information, ideas, or proposals in a structured and compelling manner. Whether it\'s a slide deck, brochure, or digital presentation, the role of graphic design is to enhance the presentation\'s visual appeal, clarity, and impact to effectively communicate with the audience.',
          linkUrl: 'https://google.com',
          styleClass: 'slice',
        },
        banners: {
          title: 'Banners',
          content: '"Banners" in graphic design refer to visual elements often used for advertising or promotional purposes, typically displayed on websites, social media, or physical locations. Graphic designers create banners by combining text, images, and design elements to capture attention, convey a message, and encourage specific actions, such as clicking through to a website or attending an event.',
          linkUrl: 'https://google.com',
          styleClass: 'slice',
        },
        posters: {
          title: 'Posters',
          content: 'A poster is a visual communication tool typically consisting of text and images arranged on a flat surface to convey a specific message or promote an event, product, or idea. Posters aim to grab viewers\' attention, communicate information effectively, and often feature eye-catching design elements to create a strong visual impact.',
          linkUrl: 'https://google.com',
          styleClass: 'slice',
        },
        installation: {
          title: 'Installation',
          content: 'An "Installation" typically refers to a large-scale, visual arrangement or display of graphic elements, often created for temporary or specific purposes. Installations can include a combination of graphics, text, images, and sometimes interactive elements to convey a message, evoke emotions, or enhance a physical space, offering a unique and immersive visual experience.',
          linkUrl: 'https://google.com',
          styleClass: 'slice',
        },
        'walls-art': {
          title: 'Wall\'s Art',
          content: '"Wall\'s Art" typically involves creating visual artworks or designs intended for large-scale applications on walls or architectural surfaces, such as murals, wall graphics, or environmental graphics. Graphic designers who specialize in this area focus on transforming physical spaces by using their artistic and design skills to convey messages, enhance aesthetics, or create immersive experiences within interior or exterior environments.',
          linkUrl: 'https://google.com',
          styleClass: 'slice',
        },
        merchandise: {
          title: 'Merchandise',
          content: '“Merchandise” refers to a range of promotional or branded products created to promote a business, event, or brand. Graphic designers play a key role in designing the visual elements and graphics that are featured on these products, such as T-shirts, mugs, hats, and more, to ensure they effectively represent and promote the brand or event.',
          linkUrl: 'https://mobidev.biz',
          styleClass: 'slice',
          positionClass: 'down-position',
        },
        'e-mailing': {
          title: 'E-mailing',
          content: '"E-mailing" in graphic design refers to the creation and design of email templates and content, including graphics, layout, typography, and visuals, for email marketing campaigns or communications. Graphic designers play a crucial role in crafting visually appealing and effective email content that aligns with branding, engages recipients, and conveys messages clearly.',
          linkUrl: 'https://mobidev.biz',
          styleClass: 'slice',
          positionClass: 'down-position',
        },
        'brand-book': {
          title: 'Brand Book',
          content: 'A "Brand Book" is a comprehensive document that serves as a style guide and reference for maintaining consistency in a brand\'s visual identity. It typically includes guidelines for logo usage, typography, color schemes, imagery, and other design elements to ensure that all brand-related materials convey a cohesive and recognizable image.',
          linkUrl: 'https://mobidev.biz',
          styleClass: 'slice',
          positionClass: 'down-position',
        },
        character: {
          title: 'Character',
          content: 'A "Character" often refers to a fictional or illustrative figure created for branding, storytelling, or marketing purposes. Graphic designers may design characters to represent a brand mascot, convey a narrative, or add a human element to visual communication, allowing for relatable and engaging interactions with an audience.',
          linkUrl: 'https://mobidev.biz',
          styleClass: 'slice',
          positionClass: 'down-position',
        },
        logo: {
          title: 'Logo',
          content: 'A "Logo" is a unique and visually distinctive symbol, mark, or emblem that represents a brand, business, or organization. It serves as a visual identifier, often incorporating typography, icons, or both, and plays a crucial role in conveying the brand\'s identity and making it recognizable to the audience.',
          linkUrl: 'https://mobidev.biz',
          styleClass: 'slice',
          positionClass: 'down-position',
        },
        'color-design': {
          title: 'Color Design',
          content: '"Color design" refers to the intentional selection and application of colors to create visual harmony, evoke emotions, and communicate effectively. Graphic designers use color theory, psychology, and aesthetics to make deliberate choices about color palettes, ensuring they align with the brand or project\'s objectives and enhance the overall visual impact of the design.',
          linkUrl: 'https://mobidev.biz',
          styleClass: 'slice',
          positionClass: 'down-position',
        },
        'brand-identity': {
          title: 'Brand Identity',
          content: '“Brand Identity” encompasses the visual elements and design choices that define how a brand presents itself to the world. It includes the logo, color palette, typography, and other visual components that establish a brand\'s unique and recognizable image, helping to shape its perception and create a consistent and cohesive brand presence across various media and touchpoints.',
          linkUrl: 'https://mobidev.biz',
          styleClass: 'slice',
          positionClass: 'down-position',
        },
      },
    };
  },
  methods: {
    ...mapActions({ fetchExpertisePageContent: '/expertise/expertise:fetch' }),
    openModal(activeItemName) {
      this.activeItem = activeItemName;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onKeydown(event) {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    },
  },
  components: {
    Footer,
    WindowModal,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ExpertiseGraphicDesign.vue